import React from "react";
import { Reveal, Kicker, CTAButton } from "@/components/landing/kit";
import { ASSETS } from "@/lib/site-data";

const Founder = () => (
  <section id="founder" className="bg-[#F9FAFC] py-24 sm:py-32">
    <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-5 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal className="relative order-2 lg:order-1">
        <div className="absolute -inset-3 -z-0 rounded-3xl bg-[#2D5BFF]/15 blur-2xl" />
        <div className="relative overflow-hidden rounded-3xl border border-[#E5E8F0] shadow-md">
          <img
            src={ASSETS.spokesperson}
            alt="Adam Phillips, Spokesperson at DSA eCommerce"
            className="h-[440px] w-full object-cover object-[50%_20%] sm:h-[540px]"
          />
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-6">
            <p className="font-heading text-lg font-bold text-white">Adam Phillips</p>
            <p className="text-sm text-white/70">Spokesperson, DSA eCommerce</p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="order-1 lg:order-2">
        <Kicker className="mb-6">A note from our spokesperson</Kicker>
        <div className="space-y-5 text-base leading-relaxed text-[#4B5262] sm:text-lg">
          <p className="text-balance font-heading text-2xl font-bold leading-snug text-[#0F1117] sm:text-3xl">
            &ldquo;We built DSA so owners could have a thriving eCommerce store —
            without living inside Seller Central.&rdquo;
          </p>
          <p>
            Nine years ago we set out to do what most agencies won&apos;t: take full
            operational ownership of a store, end to end. Not a course. Not a report. A
            senior team that builds, stocks, and runs your Amazon, Walmart, eBay, Shopify
            and Temu store like it&apos;s our own.
          </p>
          <p>
            Today, 400+ owners trust us to run their stores while they keep 100% ownership
            — and their time back. Our promise is simple: we handle the operation, you
            enjoy the growth. If that&apos;s the partner you&apos;ve been looking for, the
            first call is on us.
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-6 sm:flex-row sm:items-center">
          <span className="font-heading text-3xl font-black italic tracking-tight text-[#2D5BFF]">
            Adam Phillips
          </span>
          <CTAButton size="md" variant="outline" testId="founder-cta-button">
            Talk To Our Team
          </CTAButton>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Founder;
